import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
var toString = Object.prototype.toString;
var isType = function isType(type) {
  return function (o) {
    return toString.call(o) === "[object ".concat(type, "]");
  };
};
export var isObject = isType("Object");
export var isArray = isType("Array");
export var isString = function isString(s) {
  return typeof s === "string" || isObject("String");
};
var getBase = function getBase(url) {
  var href = url || location.href;
  var index = href.indexOf('#');
  if (index > -1) index--;else index = href.lastIndexOf('/');
  return href.slice(0, index);
};

// 从服务器链接下载文件
export var downloadFromUrl = function downloadFromUrl(url) {
  url = url.replace(/^\s*|\s*$/g, '');
  if (/^https?:\/\//.test(url) || process.env.NODE_ENV === "production") {
    console.log('download url', url);
    window.open(url);
    return false;
  }
  var base = location.origin;
  var finalUrl = base + url;
  if (!/^\//.test(url)) {
    base = getBase();
    finalUrl = base + '/' + url;
  }
  finalUrl = finalUrl.replace(location.origin, localStorage.proxyHost);
  console.log('download url', finalUrl);
  window.open(finalUrl);
};